import { DateTimePicker } from '@shoflo/polymer/components/DateTimePicker/DateTimePicker';
import { StyledErrorSpan } from '../Form.styled';
import React from 'react';
import PropTypes from 'prop-types';

export const StartDateTimePicker = ({
  broadcast,
  startDateTime,
  dateFormat,
  handleStartDateChange,
  use12Hours,
  showStartDateError,
}) => {
  return (
    <>
      <DateTimePicker
        value={startDateTime}
        dateFormat={dateFormat}
        id="broadcastStartDateTime"
        dataTestId="startDateTimeInput"
        onChange={handleStartDateChange}
        use12Hours={use12Hours}
        filterTimeFlag={false}
        onChangeRaw={(e) => e.preventDefault()}
        className={
          showStartDateError ? 'is-invalid form-control' : 'form-control'
        }
        ariaLabelledBy="startDateTimeLabel"
      />
      {showStartDateError && !broadcast && (
        <StyledErrorSpan>Uh oh! Please select the start date.</StyledErrorSpan>
      )}
    </>
  );
};

StartDateTimePicker.prototype = {
  broadcast: PropTypes.object,
  use12Hours: PropTypes.bool.isRequired,
  showStartDateError: PropTypes.bool.isRequired,
  dateFormat: PropTypes.string.isRequired,
  startDateTime: PropTypes.instanceOf(Date),
  handleStartDateChange: PropTypes.func.isRequired,
};
